<template>
  <app-layout>
    <template #header>
      <div class="text-center print:text-left">
        <h1 class="text-2xl mb-6 print:text-base">
          <span class="text-accent-brown">Bestellung vom</span><br>
          {{ $page.props.formattedOrderDate }}, KW {{ $page.props.weekOfYear }}
        </h1>
        <Link
          v-if="$page.props.customerCanComplaint"
          :href="route('complaint-index', { order })"
          class="print:none button-secondary ml-auto">
          Bestellreklamation
        </Link>
        <div class="text-left mt-8 max-w-4xl mx-auto">
          <table class="table-auto w-full max-w-xl print:max-w-none mx-auto mb-12 print:mb-6">
            <tbody>
              <tr>
                <td class="py-2 print:text-xs print:py-1 text-gray-500">Übermittelt am</td>
                <td class="py-2 print:text-xs print:py-1 text-gray-500 text-right">{{ submitDate }} Uhr</td>
              </tr>
              <tr>
                <td class="py-2 print:text-xs print:py-1 text-gray-500">Kundenummer</td>
                <td class="py-2 print:text-xs print:py-1 text-gray-500 text-right">{{ $page.props.user.customer_profile && $page.props.user.customer_profile.customer_nr ? $page.props.user.customer_profile.customer_nr : '-' }}</td>
              </tr>
            </tbody>
          </table>
          <template v-for="(group, key) in groupedProducts" :key="key">
            <h4 class="w-full max-w-xl print:max-w-none mx-auto text-lg mb-6 font-bold print:text-base print:mb-2">{{
              key ? key : 'Unkategorisiert'
            }}</h4>
            <div class="w-full max-w-xl print:max-w-none mx-auto mb-12 md:pl-4 lg:pl-8 print:mb-6">
              <table class="table-auto w-full">
                <thead>
                  <tr class="pb-4 print:border-b print:border-black">
                    <th class="w-3/4 pb-2 text-accent-brown print:text-sm print:w-full">Artikelname</th>
                    <th class="w-1/4 pb-2 text-right text-accent-brown print:text-sm print:w-16">Stück</th>
                    <th class="hidden print:table-cell print:w-12 text-right align-baseline print:pl-6">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product in group" :key="product.id">
                    <td class="py-4 border-b border-gray-300 print:border-black right text-lg print:py-1 print:text-sm">{{ product.name }} ({{ product.item_number }})</td>
                    <td class="py-4 border-b border-gray-300 print:border-black text-right text-lg print:py-1 print:text-sm">{{ product.pivot.quantity }}</td>
                    <th class="hidden border-b print:py-1 print:border-black print:table-cell print:pl-6">
                      <div class="w-6 h-6 border border-black ml-auto">

                      </div>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <p
            v-if="$page.props.labels['order.price_note']"
            class="my-8 italic flex justify-center items-center print:text-xs print:my-1">{{
            $page.props.labels['order.price_note']
          }}</p>

          <p class="my-8 italic flex justify-center items-center print:text-xs print:my-1">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Non-Food Artikel werden separat versendet.
          </p>

          <div class="mx-auto text-center print:none">
            <button class="link-button-lg" @click.prevent="onClickPrint">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
              </svg>
              Bestellung drucken
            </button>
          </div>
        </div>
      </div>
    </template>
  </app-layout>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import format from 'date-fns/format'

import AppLayout from '@/Layouts/AppLayout'

export default {
  components: {
    AppLayout,
    Link,
  },

  computed: {
    order () {
      return this.$page.props.order
    },

    groupedProducts () {
      return this.$page.props.groupedProducts
    },

    submitDate() {
      return format(new Date(this.order.submitted_at), 'dd.MM.yyyy HH:mm')
    }
  },

  methods: {
    onClickPrint() {
      window.print()
    }
  }
}
</script>
